import React, { memo } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './opinion-skeleton.scss';

export const OpinionSkeleton = memo(() => (
  <div className="opinion-skeleton mb-1_5">
    <div className="d-flex flex-wrap">
      <Skeleton className="height-32 rounded-30 w-30 me-0_5 mb-0_5" />
      <Skeleton className="height-32 rounded-30 w-30 me-0_5 mb-0_5" />
      <Skeleton className="height-32 rounded-30 w-30 me-0_5 mb-0_5" />
      <Skeleton className="height-32 rounded-30 w-40 me-0_5 mb-0_5" />
      <Skeleton className="height-32 rounded-30 w-40 me-0_5 mb-0_5" />
    </div>
    <Skeleton className="rounded-12 mt-1 mb-1_5 height-175 d-block" />
  </div>
));

OpinionSkeleton.displayName = 'OpinionSkeleton';
